(function () {
  'use strict';
  angular.module('common')
    .component('auditEvents', {
        bindings: {
          promise: '<',
          columns: '<',
          uibInstance: '<'
        },
        controller: ['gridServices', 'uiGridConstants', '$filter','$state','$scope','claimService',
          function selectMemberController(gridServices,uiGridConstants, $filter, $state,$scope,claimService) {
          var ctrl = this;

          ctrl.oldModel = undefined;
          ctrl.tzOffset = new Date().getTimezoneOffset() * 60 * 1000;
          ctrl.gridOptions = {
            enableSorting: true,
            enableColumnResizing: true,
            enableRowHeaderSelection: false,
            exporterMenuPdf: false,
            enableGridMenu: true,
            cellTooltip: true,
            columnDefs: [],
            onRegisterApi: function(api) {
              ctrl.gridApi = api;
            }

          };
          this.$onInit = function() {
            var columnDefs = {
              event: { field: 'eventData.eventName', displayName: 'Event', width: "20%",
            	  cellTemplate: '<div class="ui-grid-cell-contents" ng-show="grid.appScope.showHref(row)"><a href ng-click="grid.appScope.rowClick(row);">{{row.entity.eventData.eventName}}</a></div>' +
            	  				'<div class="ui-grid-cell-contents" ng-show="!grid.appScope.showHref(row)">{{row.entity.eventData.eventName}}</div>'},
              timestamp: { field: 'getTimestamp()' , displayName: 'Timestamp', width: "20%",
                  sortingAlgorithm: gridServices.dateSort(ctrl, (row) => row.auditData.created),
                  sort: {
                    direction: uiGridConstants.DESC,
                    priority: 0
                  }
                },
                login: { field: 'getLogin()', displayName: 'Login', width: "10%" },
                eventData: { field: 'eventData.prettyEventData', displayName: 'Event Data', cellTooltip: true}
            };
            if (!ctrl.columns || !ctrl.columns.length) {
              ctrl.columns = ['event', 'timestamp', 'login', 'eventData'];
            }
            _.each(ctrl.columns, (c) => {
              if (columnDefs[c]) {
                ctrl.gridOptions.columnDefs.push(columnDefs[c]);
              } else {
                throw c + " is not a valid column, please limit to " + _.join(_.keys(columnDefs));
              }
            });
            getAuditEvents();
          };

          function getAuditEvents() {
            ctrl.gridRunning = true;
              if (ctrl.promise) {
                  ctrl.promise.then(function(data) {
                      _.each(data, (row) => {
                          row.getLogin = function() {
                              if (this.actorLogin && this.actorLogin.indexOf('fdl.dpp.') === 0) {
                                  return this.actorLogin.substring(8);
                              } else {
                                  return this.actorLogin;
                              }
                          };
                          let dateRangeText = row.eventData.prettyEventData;
                          if (row.eventData.eventName === 'Date Range Search' && row.eventData.taxId) {
                              claimService.getFilteredTaxIdLocations(row.eventData.taxId, row.eventData.locations).then(function (result) {
                                  row.eventData.prettyEventData = dateRangeText.substring(0, dateRangeText.indexOf("Locations:")) + "Locations: " + result;

                              });
                          }
                          row.getTimestamp =  function() {
                              let d = new Date(this.auditData.created).getTime();
                              return $filter('date')(d - ctrl.tzOffset, 'M/d/yy h:mm a');
                          };
                      });
                      ctrl.gridOptions.data = data;
                      ctrl.gridRunning = false;
                  }, function(rejection) {
                      ctrl.gridRunning = false;
                  });
              }
          }


    	  $scope.rowClick = function( row) {
    		  //console.log(">>> auditEventsComponent referenceId: " + row.entity.eventData.refId +" uuid: "+ row.entity.uuid+" eligibilityAuditTS "+row.entity.auditData.created);
    		  if(row.entity.uuid !=null){
    			  ctrl.uibInstance.dismiss();
    			  $state.go('benefits.dashboard', {'referenceId': row.entity.eventData.refId, 'uuid': row.entity.uuid,'eligibilityAuditTS': row.entity.auditData.created});
    		  }
    	  };

    	  $scope.showHref = function( row) {
     		  if(row.entity.uuid != null){
     			  var sixMonthOld = new Date();
     			  sixMonthOld.setMonth(sixMonthOld.getMonth() - 6);
     			  var auditCreated = new Date(row.entity.auditData.created);
       		  	  if(auditCreated.getTime() > sixMonthOld.getTime()){
       		  		  return true;
       		  	  } else {
       		  		  return false;
       		  	  }
    		  } else {
    			  return false;
    		  }
    	  }
        }],
        templateUrl: 'js/common/auditEvents.html' + appVersion
      }
    );
})();
